import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOwnerShipGroupType } from "Shared/Types/ownerShipGroupType";
import { RootState } from "Redux/store";
import { getOwnerShipGroupList, addOwnerShipGroup } from "./OwnerShipTypeReducer";

interface IOwnerShipGroupState {
  list: IOwnerShipGroupType[];
  loading: boolean;
  error: string | null;
  count: number;
  next: string | null;
  previous: string | null;
}

const initialState: IOwnerShipGroupState = {
  list: [],
  loading: false,
  error: null,
  count: 0,
  next: null,
  previous: null,
};

const ownerShipGroupSlice = createSlice({
  name: "ownerShipGroup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOwnerShipGroupList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOwnerShipGroupList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results;
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
      })
      .addCase(getOwnerShipGroupList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch ownership groups";
      })
      .addCase(addOwnerShipGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOwnerShipGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(addOwnerShipGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add ownership group";
      });
  },
});

export const selectOwnerShipGroupList = (state: RootState) => state.ownerShipGroup.list;
export const selectOwnerShipGroupLoading = (state: RootState) => state.ownerShipGroup.loading;
export const selectOwnerShipGroupError = (state: RootState) => state.ownerShipGroup.error;

export default ownerShipGroupSlice;